import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "40",
  height: "40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M10 26.6667c0 3.6819 2.9848 6.6667 6.6667 6.6667h6.6666c3.6819 0 6.6667-2.9848 6.6667-6.6667C30 22.9848 27.0152 20 23.3333 20h-6.6666C12.9848 20 10 17.0153 10 13.3334c0-3.682 2.9848-6.6667 6.6667-6.6667h6.6666C27.0152 6.6667 30 9.6515 30 13.3334m-10-10v33.3333",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }